import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'op-product-dashboard',
    templateUrl: './product-dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDashboardComponent {

}